module.exports = __webpack_public_path__ + "06_hige_black.5a57a8fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/06_hige_black.png
// module id = 6ru7
// module chunks = 0